// Shared bits of the admin home — v2 « cockpit » (owner, 2026-10-22): the card
// shell, its title row, the delta chip and the « données manquantes » mark.
// Night mode: tokens only (dashboard.night.guard.test.ts scans this file).
import type { ReactNode } from 'react';
import { chip as toneChip } from '@/components/admin/dashTone';

export const HEADING_FONT = "'Fraunces', 'Cormorant Garamond', Georgia, serif";

/** The warm hairline of the v2 cards (#ECE5D6 on light; the line token at night). */
export const CARD_BORDER = 'border-[#ECE5D6] dark:border-adm-line';

export function HomeCard({ children, className = '', id }: { children: ReactNode; className?: string; id?: string }) {
  return (
    <section id={id} className={`bg-white rounded-[14px] border ${CARD_BORDER} px-4 py-3.5 min-w-0 scroll-mt-24 ${className}`}>
      {children}
    </section>
  );
}

/** « À faire maintenant [8] ……… right » */
export function HomeCardTitle({ label, count, sub, right }: { label: string; count?: number | null; sub?: ReactNode; right?: ReactNode }) {
  return (
    <div className="flex items-center gap-2.5 mb-2 min-w-0">
      <h2 className="text-[14px] font-bold text-adm-ink tracking-[-0.005em] shrink-0 m-0" style={{ fontFamily: "var(--font-sans)" }}>{label}</h2>
      {count != null && (
        <span className="rounded-full px-2 py-px text-[11.5px] font-bold bg-[#2B2116] text-[#FBF7EC] dark:bg-adm-gold dark:text-[#2B2116] shrink-0">{count}</span>
      )}
      {sub && <span className="text-[12.5px] text-adm-muted truncate min-w-0">{sub}</span>}
      {right && <div className="ml-auto flex items-center gap-1.5 min-w-0">{right}</div>}
    </div>
  );
}

const CHIP = { up: toneChip('done'), down: toneChip('stuck'), neutral: toneChip('muted') } as const;

export function DeltaChip({ c, title }: { c: { text: string; tone: 'up' | 'down' | 'neutral' } | null; title?: string }) {
  if (!c) return null;
  // 7-card KPI row (2026-10-22): a touch tighter on xl so the labels keep their words.
  return <span title={title} className={`text-[11px] xl:text-[10.5px] font-bold px-1.5 xl:px-1 py-px rounded-full whitespace-nowrap shrink-0 ${CHIP[c.tone]}`}>{c.text}</span>;
}
